/**
 * Generated by orval v7.4.1 🍺
 * Do not edit manually.
 * Default API
 * All endpoints not defined under specific APIs
 * OpenAPI spec version: Latest
 */
import {
  useMutation,
  useQuery,
  useSuspenseQuery
} from '@tanstack/react-query'
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query'
import type {
  IBaseIdentityModel,
  PostUmbracoApiMrmSessionSignInSessionId401One,
  PostUmbracoApiMrmSessionSignInSessionId401Three,
  PostUmbracoApiMrmSessionSignInSessionId401Two
} from '../../models'
import { customInstance } from '../../../utils/mutator/custom-instance';
import type { ErrorType } from '../../../utils/mutator/custom-instance';

type AwaitedInput<T> = PromiseLike<T> | T;

      type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;


type SecondParameter<T extends (...args: any) => any> = Parameters<T>[1];


export const postUmbracoApiDevBackdoorSignIn = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/umbraco/api/dev/backdoor/sign-in`, method: 'POST', signal
    },
      options);
    }
  


export const getPostUmbracoApiDevBackdoorSignInMutationOptions = <TData = Awaited<ReturnType<typeof postUmbracoApiDevBackdoorSignIn>>, TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<TData, TError,void, TContext>, request?: SecondParameter<typeof customInstance>}
) => {
const mutationKey = ['postUmbracoApiDevBackdoorSignIn'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postUmbracoApiDevBackdoorSignIn>>, void> = () => {
          

          return  postUmbracoApiDevBackdoorSignIn(requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions } as UseMutationOptions<TData, TError,void, TContext>}

    export type PostUmbracoApiDevBackdoorSignInMutationResult = NonNullable<Awaited<ReturnType<typeof postUmbracoApiDevBackdoorSignIn>>>
    
    export type PostUmbracoApiDevBackdoorSignInMutationError = ErrorType<void>

    export const usePostUmbracoApiDevBackdoorSignIn = <TData = Awaited<ReturnType<typeof postUmbracoApiDevBackdoorSignIn>>, TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<TData, TError,void, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationResult<
        TData,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getPostUmbracoApiDevBackdoorSignInMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const postUmbracoApiMrmSessionSignInSessionId = (
    sessionId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/umbraco/api/mrm/session/sign-in/${sessionId}`, method: 'POST', signal
    },
      options);
    }
  


export const getPostUmbracoApiMrmSessionSignInSessionIdMutationOptions = <TData = Awaited<ReturnType<typeof postUmbracoApiMrmSessionSignInSessionId>>, TError = ErrorType<PostUmbracoApiMrmSessionSignInSessionId401One | PostUmbracoApiMrmSessionSignInSessionId401Two | PostUmbracoApiMrmSessionSignInSessionId401Three | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<TData, TError,{sessionId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
) => {
const mutationKey = ['postUmbracoApiMrmSessionSignInSessionId'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postUmbracoApiMrmSessionSignInSessionId>>, {sessionId: string}> = (props) => {
          const {sessionId} = props ?? {};

          return  postUmbracoApiMrmSessionSignInSessionId(sessionId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions } as UseMutationOptions<TData, TError,{sessionId: string}, TContext>}

    export type PostUmbracoApiMrmSessionSignInSessionIdMutationResult = NonNullable<Awaited<ReturnType<typeof postUmbracoApiMrmSessionSignInSessionId>>>
    
    export type PostUmbracoApiMrmSessionSignInSessionIdMutationError = ErrorType<PostUmbracoApiMrmSessionSignInSessionId401One | PostUmbracoApiMrmSessionSignInSessionId401Two | PostUmbracoApiMrmSessionSignInSessionId401Three | void>

    export const usePostUmbracoApiMrmSessionSignInSessionId = <TData = Awaited<ReturnType<typeof postUmbracoApiMrmSessionSignInSessionId>>, TError = ErrorType<PostUmbracoApiMrmSessionSignInSessionId401One | PostUmbracoApiMrmSessionSignInSessionId401Two | PostUmbracoApiMrmSessionSignInSessionId401Three | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<TData, TError,{sessionId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationResult<
        TData,
        TError,
        {sessionId: string},
        TContext
      > => {

      const mutationOptions = getPostUmbracoApiMrmSessionSignInSessionIdMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const getUmbracoApiUser = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<IBaseIdentityModel>(
      {url: `/umbraco/api/user`, method: 'GET', signal
    },
      options);
    }
  

export const getGetUmbracoApiUserQueryKey = () => {
    return [`/umbraco/api/user`] as const;
    }

    
export const getGetUmbracoApiUserQueryOptions = <TData = Awaited<ReturnType<typeof getUmbracoApiUser>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUmbracoApiUser>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUmbracoApiUserQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUmbracoApiUser>>> = ({ signal }) => getUmbracoApiUser(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUmbracoApiUser>>, TError, TData> & { queryKey: QueryKey }
}

export type GetUmbracoApiUserQueryResult = NonNullable<Awaited<ReturnType<typeof getUmbracoApiUser>>>
export type GetUmbracoApiUserQueryError = ErrorType<unknown>



export function useGetUmbracoApiUser<TData = Awaited<ReturnType<typeof getUmbracoApiUser>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUmbracoApiUser>>, TError, TData>, request?: SecondParameter<typeof customInstance>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetUmbracoApiUserQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetUmbracoApiUserSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getUmbracoApiUser>>, TError = ErrorType<unknown>>( options?: { query?:UseSuspenseQueryOptions<Awaited<ReturnType<typeof getUmbracoApiUser>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUmbracoApiUserQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUmbracoApiUser>>> = ({ signal }) => getUmbracoApiUser(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getUmbracoApiUser>>, TError, TData> & { queryKey: QueryKey }
}

export type GetUmbracoApiUserSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getUmbracoApiUser>>>
export type GetUmbracoApiUserSuspenseQueryError = ErrorType<unknown>



export function useGetUmbracoApiUserSuspense<TData = Awaited<ReturnType<typeof getUmbracoApiUser>>, TError = ErrorType<unknown>>(
  options?: { query?:UseSuspenseQueryOptions<Awaited<ReturnType<typeof getUmbracoApiUser>>, TError, TData>, request?: SecondParameter<typeof customInstance>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetUmbracoApiUserSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const postUmbracoApiUserSignOut = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/umbraco/api/user/sign-out`, method: 'POST', signal
    },
      options);
    }
  


export const getPostUmbracoApiUserSignOutMutationOptions = <TData = Awaited<ReturnType<typeof postUmbracoApiUserSignOut>>, TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<TData, TError,void, TContext>, request?: SecondParameter<typeof customInstance>}
) => {
const mutationKey = ['postUmbracoApiUserSignOut'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postUmbracoApiUserSignOut>>, void> = () => {
          

          return  postUmbracoApiUserSignOut(requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions } as UseMutationOptions<TData, TError,void, TContext>}

    export type PostUmbracoApiUserSignOutMutationResult = NonNullable<Awaited<ReturnType<typeof postUmbracoApiUserSignOut>>>
    
    export type PostUmbracoApiUserSignOutMutationError = ErrorType<unknown>

    export const usePostUmbracoApiUserSignOut = <TData = Awaited<ReturnType<typeof postUmbracoApiUserSignOut>>, TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<TData, TError,void, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationResult<
        TData,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getPostUmbracoApiUserSignOutMutationOptions(options);

      return useMutation(mutationOptions);
    }
    